// @flow
import React, { Component, Fragment } from 'react';
import classNames from 'classnames/bind';
import { defineMessages, intlShape } from 'react-intl';

import style from './BannerStrip.scss';
import PropTypes from 'prop-types';

import icons from '../../../../assets/styles/icons.scss';

import type { LocaleState } from '../../../locale/duck';

type Props = {
  +locale: LocaleState;
};

const messages = defineMessages({
  text1: {
    id: 'banner.purchaser.text1',
  },
  text1Half: {
    id: 'banner.purchaser.text1.half',
  },
  free: {
    id: 'banner.purchaser.free',
  },
  text2: {
    id: 'banner.purchaser.text2',
  },
});

export default class BannerStrip extends Component<Props> {

  render() {
    const { locale } = this.props;
    return (
      <Fragment>
        <section className={style.bannerWrap}>
          <section className={style.bannerContent}>
            <i className={icons.iconRewardMedium}/>
            <section className={style.textWrap}>
              <p className={style.white}>
                {this.context.intl.formatMessage(messages.text1)}&nbsp;
                <span>
                {this.context.intl.formatMessage(messages.free)}&nbsp;</span>
              </p>
              {locale.locale === 'en' && <p className={style.white}>
                {this.context.intl.formatMessage(messages.text1Half)}&nbsp;</p>}
              <a className={style.moreInfo} href="https://www.qempo.com.pe/blog/envio-internacional-gratis/"
                 target="_blank">
                {this.context.intl.formatMessage(messages.text2)}</a>
            </section>
          </section>
        </section>
      </Fragment>
    );
  }
}

BannerStrip.propTypes = {
  locale: PropTypes.object.isRequired,
};

BannerStrip.contextTypes = {
  intl: intlShape,
};



// WEBPACK FOOTER //
// ./src/modules/new-order/components/BannerStrip/BannerStrip.jsx